<template>
  <div class="news">
    <Head :index="'10'"></Head>
    <div class="catalogue">
      <div class="nav">栏目导航</div>
      <ul class="nav-list">
        <li 
          class="nav-item" 
          :class="{ active: selectedType === category.id }" 
          v-for="category in categories" 
          :key="category.id" 
          @click="handleCategoryClick(category.id)"
        >
          {{ category.name }}
        </li>
      </ul>
    </div>
    <div class="content">
      <!-- 栏目介绍 -->
      <div class="introduction">
        <h3>{{ currentCategory.description }}</h3>
      </div>

      <!-- 添加按钮 -->
      <div v-if="showAddButton" class="add-button">
        <button class="primary-btn" @click="handleAdd()">添加新内容</button>
      </div>
    

      <!-- 数据表格 -->
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th>标题</th>
              <th>时间</th>
              <th>发布人</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in list" :key="item.id">
              <td>{{ item.title }}</td>
              <td>{{ item.createTime }}</td>
              <td>{{ item.createUser }}</td>
              <td>查看详情</td>
            </tr>
          </tbody>
        </table>
        
        <!-- 分页组件 -->
        <div class="pagination">
          <span>第 {{ page }} 页 / 共 {{ totalPage }} 页</span>
          <button @click="changePage(1)">首页</button>
          <button @click="changePage(page - 1)" :disabled="page === 1">上一页</button>
          <button @click="changePage(page + 1)" :disabled="page === totalPage">下一页</button>
          <button @click="changePage(totalPage)">末页</button>
        </div>
      </div>
    </div>
    <!-- 添加新内容 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogNews" width="80%" :z-index="5"  style="margin-top:-6vh">
      <div>
          <el-form ref="form" label-width="70px" :model="newsForm">
              <el-form-item label="标题" prop="title">
                  <el-input type="text" placeholder="请输入标题" autocomplete="off" v-model="newsForm.title"></el-input>
              </el-form-item>
              <el-form-item label="内容" prop="familyname">
                <vue-ueditor-wrap
                  v-model="newsForm.content"
                  editor-id="editor6"
                  :config="editorConfig"
                  :editorDependencies="['ueditor.config.js', 'ueditor.all.js']"
                />
              </el-form-item>
              <el-form-item label="审核">
              <el-radio-group v-model="newsForm.verify">
                <el-radio :label="true">是</el-radio>
                <el-radio :label="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
              <el-form-item>
                  <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
              </el-form-item>
          </el-form>
      </div>
            
    </el-dialog>

  </div>
</template>

<script>
import Head from "@/components/header.vue";
import api from "@/request/api";
import VueUeditorWrap from "vue-ueditor-wrap";
import base from "@/request/base";
export default {
  data() {
    return {
      editorConfig: {
        serverUrl: base.baseURL + 'news/upload',
        UEDITOR_HOME_URL: '/static/UEditor/',
        UEDITOR_CORS_URL: '/static/UEditor/',
        initialFrameHeight: 400, //初始高度
      },
      newsForm:{
        title:"",
        content:"",
        verify:false
      },
      categories: [
        { id: 1, name: '家族新闻和公告', description: '发布关于家族的重大新闻、重要公告和通知。' },
        { id: 2, name: '家族成就和荣誉', description: '展示家族成员在个人事业、学术研究、社会贡献等方面的成就和获得的荣誉。' },
        { id: 3, name: '家族各分支情况', description: '介绍各分支迁徙时间、始迁(祖)人、成员数量、文化结构、分布地区、主要人物、经济状况等。' },
        { id: 4, name: '家族活动和聚会', description: '记录家族组织的各种活动，如祭祀活动、团聚、庆祝活动、公益活动等，以及这些活动的文字、照片、视频。' },
        { id: 5, name: '家族成员的动态', description: '分享家族成员的生活点滴、旅行见闻、学习心得等，增进家族成员之间的了解和亲近感。' },
        { id: 6, name: '家族文化的传承', description: '介绍家族历史、祖先事迹、家族故事、家族传统和价值观，家规、家训教育等。' },
        { id: 7, name: '家族教育和发展', description: '探讨家族对下一代教育的重视，包括家庭教育理念、教育资源的利用以及家族成员的职业发展支持。' },
        { id: 8, name: '家族之社会责任', description: '展示家族及其成员在社会责任方面的努力和贡献，如扶贫救困、慈善捐赠、风义勇为等。' },
        { id: 9, name: '家族的财产管理', description: '涉及家族财富的管理和传承，包括家族捐助、集资款(物)的使用、管理情况公示，以及家族有形与无形资产的传承与保护。' },
      ],
      permission: -1, // 权限值：-1(默认), 0(超级权限), 1+(普通权限)
      selectedType: 1,
      currentCategory: {},
      list: [],
      page: 1,
      limit: 10,
      total: 0,
      showAddForm: false,
      dialogNews: false,
    };
  },
  components: {
    Head,
    VueUeditorWrap
  },
  computed: {
    totalPage() {
      return Math.ceil(this.total / this.limit) || 1;
    },
    showAddButton() {
      console.log(this.permission);
      // 权限判断逻辑
      if (this.permission === 0) {
        // 超级权限：所有栏目显示添加按钮
        return true;
      } else if (this.permission > 0) {
        // 普通权限：仅id为3、4、8的栏目显示（对应第三、四、八项）
        return [3, 4, 8].includes(this.selectedType);
      } else {
        // 无权限或负数：仅id为5的栏目显示（第五项）
        return this.selectedType === 5;
      }
    }
  },
  mounted() {
    this.currentCategory = this.categories.find(c => c.id === this.selectedType);
    this.loadData();
    // 获取权限数据
    api.getpermission(localStorage.getItem('fid'))
      .then(res => {
        this.permission = res.data; // 确保有默认值
      })
      .catch(err => {
        console.error('权限获取失败', err);
        this.permission = -1; // 失败时设为默认值
      });
  },
  methods: {
    handleCategoryClick(type) {
      this.selectedType = type;
      this.currentCategory = this.categories.find(c => c.id === type);
      this.page = 1;
      this.loadData();
    },
    loadData() {
      const params = {
        type: this.selectedType,
        page: this.page,
        limit: this.limit
      };
      api.getnews(params)
        .then(res => {
          if (res.code === 200) {
            this.list = res.data.list || [];
            this.total = res.data.total || 0;
          }
        })
        .catch(err => {
          console.error('数据加载失败', err);
        });
    },
    changePage(newPage) {
      if (newPage < 1 || newPage > this.totalPage) return;
      this.page = newPage;
      this.loadData();
    },
    handleAdd() {
     this.dialogNews = true;
    },
    handleSubmit() {
      // 在提交前将 selectedType 赋值给 formData.type
      this.formData.type = this.selectedType;
      api.addNews(this.formData)
        .then(res => {
          if (res.code === 200) {
            this.showAddForm = false;
            this.formData = {
              title: '',
              content: '',
              isReviewed: false,
              type: null
            };
            this.loadData();
          }
        })
        .catch(err => {
          console.error('提交失败', err);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.news {
  overflow: hidden;
  height: 100%;
  background: #f8f9fa;

  .catalogue {
    width: 200px;
    height: 100%;
    float: left;
    padding: 0;
    box-sizing: border-box;
    border-right: 1px solid #ebedf0;
    overflow: auto;
    position: relative;
    z-index: 1;
    background: #fff;
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.03);

    .nav {
      font-size: 16px;
      font-weight: 600;
      background: #ffece4;
      color: #333;
      padding: 15px 30px;
      position: relative;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 30px;
        right: 30px;
        height: 2px;
        background: linear-gradient(90deg, #e04428 20%, #ffece4 100%);
      }
    }

    .nav-list {
      padding-left: 0;
      list-style: none;
      margin-top: 10px;

      .nav-item {
        padding: 12px 30px;
        margin: 6px 0;
        border-radius: 0 20px 20px 0;
        font-size: 14px;
        color: #666;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        position: relative;
        display: flex;
        align-items: center;
        line-height: 1.5;

        &::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 0;
          background: #e04428; 
          transition: all 0.3s;
        }

        &:hover, &.active {
          color: #e04428;
          background: #fff5f3;
          transform: translateX(8px);
          
          &::before {
            height: 60%;
          }
        }

        &:active {
          transform: translateX(5px);
          transition-duration: 0.1s;
        }
      }

      .nav-item + .nav-item {
        border-top: 1px dashed #ffd9d1;
      }
    }
  }

  .content {
    margin-left: 200px;
    padding: 20px 30px;
    box-sizing: border-box;
    height: 100%;
    overflow: auto;

    .introduction {
      margin-bottom: 20px;
      padding: 20px;
      background: white;
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    }

    .add-button {
      margin: 20px 0;
      text-align: right; // 按钮靠右
    }

    .primary-btn {
      padding: 8px 16px;
      border: none;
      border-radius: 4px;
      background-color: #e04428;
      color: white;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: #c93e25;
      }
    }

    .table-container {
      background: #fff;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0,0,0,0.05);

      .data-table {
        width: 100%;
        border-collapse: collapse;

        th, td {
          padding: 12px 15px;
          text-align: left;
          border-bottom: 1px solid #ebedf0;

          &:first-child {
            width: 30%;
          }
        }

        th {
          background: #f8f9fa;
          color: #2c3e50;
          font-weight: 600;
        }
      }

      .pagination {
        margin-top: 20px;
        text-align: right;
        color: #5a5e66;

        button {
          margin-left: 10px;
          padding: 6px 12px;
          border: 1px solid #ebedf0;
          border-radius: 4px;
          background: #fff;
          cursor: pointer;

          &:disabled {
            color: #c0c4cc;
            cursor: not-allowed;
            border-color: #c0c4cc;
          }
        }
      }
    }
  } 
}
</style>


// WEBPACK FOOTER //
// src/views/news.vue